<template>
  <div class="columns">
    <div class="column is-one-quarter">
      <div class="columns is-multiline">
        <div class="column is-12">
          <a :href="templateFile" class="button is-outlined">
            Télécharger le fichier gabarit.
          </a>
        </div>
        <div class="column is-12">
          <div class="file is-boxed is-primary">
            <label class="file-label">
              <input class="file-input" type="file" name="resume" @change="processFile($event)">
              <span class="file-cta">
                <span class="file-icon">
                  <i class="fas fa-upload"></i>
                </span>
                <span class="file-label">
                  Envoyer le fichier
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="columns" v-if="uploading">
        chargement en cours...
      </div>
      <div class="columns" v-if="result && !uploading">
        <div class="column card">
          Total : {{result.total}}<br>
          Importé(s) : {{result.valid}}<br>
          Erreur(s) : {{result.errors.length}}<br>
        </div>
      </div>
      <div class="columns" v-if="result && !uploading">
        <div class="column is-12">
          <div v-for="error in result.errors" class="columns card">
            <div class="column is-one-third">
              <span v-if="error.row">Ligne : {{error.row}} <br></span>
              <span v-if="error.col">Colonne : {{error.col}} <br></span>
            </div>
            <div class="column">
              {{error.description}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'ProgramLotImport',
    data () {
      return {
        result: null,
        uploading: false
      }
    },
    computed: {
      programPk () {
        return this.$route.params.id
      },
      templateFile () {
        const apiRoot = this.$configs.APIROOT
        return `${apiRoot}/ressources/lots-import-template.xlsx`
      },
      importUrl () {
        const apiRoot = this.$configs.APIROOT
        return `${apiRoot}/import/lots/${this.programPk}`
      }
    },
    methods: {
      async processFile (event) {
        this.$set(this, 'result', null)
        let file = event.target.files[0]
        let files = new FormData()
        files.append('file', file, file.name)
        this.uploading = true
        try {
          let response = await axios.post(this.importUrl, files)
          console.log(response.data)
          this.uploading = false
          this.$set(this, 'result', response.data)
          event.target.value = ''
        } catch (error) {
          console.log(error)
          this.uploading = false
          event.target.value = ''
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/program/ProgramLotsImport.vue